<template lang="html">
  <div id="original-prompt" class="relative">
    <div
      id="prompt-card-in-feed"
      class="col-xs-12 top-xs original-prompt-container feed-card readable-text relative"
      :style="dyanamic_styles"
      :class="prompt_card_dynamic_classes"
      @click="is_expanded = true"
    >
      <walkthrough
        v-show="!editPrompt"
        componentName="Prompt"
        class="walkthrough-position"
      />
      <div class="edit-prompt end-xs pl-caption">
        <div class="relative flex justify-between items-center">
          <div v-if="!editPrompt" class="flex items-center justify-between">
            <div class="flex">
              <div class="avatar-rounded avatar-size fr mr3">
                <img
                  v-if="getRoundtableAuthor.email === getProfile.email"
                  :src="getProfile.avatar_url"
                  alt="avatar"
                />
                <img
                  v-else
                  :src="getRoundtableAuthor.avatar_url"
                  alt="avatar"
                />
              </div>
              <div class="tl pl-caption mr3">
                <p class="ma0">Discussion prompt by:</p>
                <p class="ma0 pl-title">
                  {{
                    getRoundtableAuthor.preferred_name ||
                    getRoundtableAuthor.name
                  }}
                </p>
              </div>
            </div>
          </div>

          <pl-button
            key="collapse"
            v-if="is_expanded && submission_cards_exist && !editPrompt"
            v-my-tooltip="'collapse'"
            @click.stop.native="is_expanded = !is_expanded"
            class="pl-icon no-margin"
          >
            <img
              style="max-width: 15px"
              src="/static/minimize.svg"
              alt="collapse prompt"
            />
          </pl-button>

          <div
            v-if="hasTeacherPermissionsInCourse && !editPrompt"
            class="flex-grow"
          >
            <pl-button
              @click.native="openEdit"
              class="edit-roundtable-button pl-charcoal-font"
            >
              <i class="fa fa-pencil-square-o" />
              Edit
            </pl-button>
          </div>
        </div>
      </div>
      <!-- Prompt text content -->
      <template v-if="!editPrompt">
        <base target="_blank" />
        <div v-if="getCurrentRT.prompt" class="start-xs">
          <!-- <div v-html="prompt_adjusted_with_links" class="pl-body-1"/> -->
          <div
            v-show="is_expanded || !submission_cards_exist"
            v-html="prompt_adjusted_with_links"
            class="pl-body-1"
          />
          <div
            v-show="!is_expanded && submission_cards_exist"
            class="ellipsis-text tl mt3"
          >
            {{ prompt_text_only }}
          </div>
          <!-- <div v-show="!is_expanded && submission_cards_exist" v-html="`${prompt_adjusted_with_links.slice(0, 102)}...`" class="truncate-text tl mt3"/> -->
        </div>
        <!-- When there is no prompt (this is the template picker, not currently used) -->
        <!-- <template v-else-if="hasTeacherPermissionsInCourse">
          <template-picker @templateChoice="saveTemplate" />
        </template> -->
      </template>
      <!-- <div
        v-show="editPrompt"
        class="flex flex-column items-center"
        style="height: 100%"
      >
        <div
          class="roundtable-title-div"
          style="margin-bottom: 10px; width: 620px"
        >
          <div style="margin-right: 10px">Title:</div>
          <pl-input v-model="roundtable_title" style="flex-grow: 1"> </pl-input>
        </div>
        <build
          class="rt-create-modal"
          @saveRoundtable="savePayload"
          @isSaving="is_saving = true"
        />
        <div class="flex self-end" style="height: 50px">
          <pl-button
            @click.native="openEdit"
            class="pl-small"
            style="
              color: black;
              font-size: 16px;
              height: 30px;
              margin-top: 20px;
            "
          >
            Close
          </pl-button>
          <pl-button
            @click.native="saveRoundtable(payload_with_changes)"
            class="pl-small pl-primary"
            style="
              color: #f0f0f0;
              font-weight: bold;
              font-size: 16px;
              height: 30px;
              margin-top: 20px;
            "
          >
            Save and Close
          </pl-button>
        </div>
      </div> -->
    </div>

    <!-- Modals -->
    <share-to-universe-modal
      v-if="show_share_to_universe_modal"
      @close="show_share_to_universe_modal = false"
    />
  </div>
</template>

<script>
  import Build from 'features/onlineRoundtables/components/editBuild/editBuild.vue';
  import Walkthrough from 'features/onlineWalkthrough/onlineWalkthroughDot';
  import shareToUniverseModal from 'features/onlineRoundtables/components/shareToUniverseModal/shareToUniverseModal';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default {
    watch: {
      editPrompt() {
        window.renderMath();
      },
    },
    created() {
      this.roundtable_title = this.getCurrentRT.title;
    },
    mounted() {
      window.renderMath();
      this.payload_with_changes.prompt = this.getCurrentRT.prompt;
      EventBus.$on('promptChanged', (changes) => {
        this.payload_with_changes.prompt = changes;
      });
      this.openRTWelcomeTutorial();
    },
    data() {
      return {
        is_saving: false,
        prompt_changed: false,
        payload_with_changes: { id: '', prompt: ' ', title: '' },
        show_share_to_universe_modal: false,
        is_expanded: false,
        roundtable_title: 'RoundTable',
      };
    },
    props: {
      editPrompt: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Build,
      Walkthrough,
      shareToUniverseModal,
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCurrentRT',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getOnboarding',
        'getRoundtableAuthor',
        'getSubmissionsBySubmitStatus',
      ]),
      show_save_and_close_button() {
        return (
          !this.is_saving &&
          (this.payload_with_changes || this.changed_rt_title)
        );
      },
      changed_rt_title() {
        return this.getCurrentRT.title !== this.roundtable_title;
      },
      dyanamic_styles() {
        return this.editPrompt
          ? {
              display: 'flex',
              'flex-flow': 'column',
              'align-items': 'flex-end',
            }
          : {};
      },
      submission_cards_exist() {
        return (
          this.getSubmissionsBySubmitStatus.submitted.length ||
          this.getSubmissionsBySubmitStatus.by_passed.length
        );
      },
      prompt_adjusted_with_links() {
        let prompt = this.getCurrentRT.prompt;
        let listItemsString = '';
        if (this.getCurrentRT.links.length > 0) {
          this.getCurrentRT.links.forEach((link) => {
            const linkTag = `<li> <a href="${link.link}"target="_blank"> ${link.title} </a></li>`;
            listItemsString = listItemsString.concat(linkTag);
          });
          prompt = prompt.concat(`<hr /> Links: <ol> ${listItemsString} </ol>`);
        }
        return prompt;
      },
      prompt_text_only() {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          this.prompt_adjusted_with_links,
          'text/html'
        );
        return doc.documentElement.innerText;
      },
      user_opted_for_not_showing_explanation() {
        return this.getOnboarding.prompt_explanation;
      },
      prompt_card_dynamic_classes() {
        return {
          'edit-mode': this.editPrompt,
          'minimize-prompt': !this.is_expanded,
        };
      },
    },
    methods: {
      // this is the template picker, not currently used
      // saveTemplate(payload) {
      //   this.is_saving = true;
      //   payload.id = this.getCurrentRT.id;
      //   this.$store.dispatch('savingRTDetails', payload)
      //   .then(() => {
      //     this.$emit('toggleEditPrompt');
      //   });
      // },
      saveRoundtable(payload) {
        this.is_saving = true;
        payload.id = this.getCurrentRT.id;
        payload.title = this.roundtable_title;
        if (
          this.roundtable_title.length < 4 ||
          this.roundtable_title.length > 99
        ) {
          EventBus.$emit(
            'toast-msg',
            'Provide a Title (between 4 and 99 characters)'
          );
          return;
        }
        this.$store
          .dispatch('savingRTDetails', payload)
          .then(() => {
            this.is_saving = false;
            this.$emit('toggleEditPrompt');
            // this.openRTWelcomeTutorial();
            this.deleteCreateParam();
          })
          .catch((err) => {
            EventBus.$emit(
              'toast-msg',
              'There was an error saving your prompt. Please try again.'
            );
            console.error(err);
            this.is_saving = false;
          });
      },
      openRTWelcomeTutorial() {
        if (
          this.getCourseDetail &&
          this.getCourseDetail.roundtables &&
          this.getCourseDetail.roundtables.length == 1 &&
          this.hasTeacherPermissionsInCourse &&
          this.$route.query.user_created
        ) {
          EventBus.$emit('showRountableWelcomeModal');
        }
      },
      savePayload(payload) {
        this.payload_with_changes = payload;
        setTimeout(() => {
          this.prompt_changed = true;
          this.is_saving = false;
        }, 0);
      },
      deleteCreateParam() {
        let query = Object.assign({}, this.$route.query);
        if (query.user_created) {
          delete query.user_created;
          this.$router.replace({ query });
        }
      },
      openEdit() {
        this.$emit('toggleEditPrompt');
        this.roundtable_title = this.getCurrentRT.title;
        this.prompt_changed = false;
        this.is_saving = true;
        // this.openRTWelcomeTutorial();
        this.deleteCreateParam();
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl';
  .roundtable-title-div
    text-align: left;
    font-weight: bold
    display:flex
    height:40px
    align-items:center
    .input-container
      display:flex
      align-items:center
      height:100%
  .feed-card
    padding: 1em 2em
  .original-prompt-container
    background: #fff
    border: 2px solid #e6e7e7
    border-radius: 5px
    max-width: 680px
    margin: 1em auto
    overflow-y: hidden
  .transparent-modal
    left: 0
    top: 0
    display: block
    position: fixed
    z-index: 998
    width: 100%
    height: 100%
    overflow-y: hidden
    background: rgba(0,0,0,0.2)
  .rt-create-modal
    width:100%;
    border-width: unset !important;
    flex-grow : 1
    border: 2px solid #e1e8ee !important
    border-radius: 5px
  .edit-mode
    z-index: 999
    position: fixed
    width: 680px
    height: 95%
    margin: 0
    left: 50%;
    margin-left: -340px
    margin-top: 1.25%
    top: 0;
    @media only screen and (max-width: 680px)
      width: 100%
      margin-left: 0
      left 0
  .minimize-prompt:hover
    border-color: alpha(pl-secondary, 0.7)
    cursor: pointer
  .avatar-size
    width: 50px
    height: 50px
    img
      height: 100%
  .walkthrough-position
    position: absolute
    right: 10px
    top: 10px
  .ellipsis-text
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
</style>

<style lang="stylus">
  #editor_ifr
    height:100% !important
    overflow: auto !important
    &&::-webkit-scrollbar
      display:none
  .rt-create-modal
    .tox
      .tox-editor-container
        .tox-editor-header
          .tox-toolbar
              width: 95% !important
  .mce-edit-area
    flex-grow:1
  .mce-container-body
    display: flex
    flex-direction: column
  *::webkit-scrollbar
      display:none !important
</style>



// WEBPACK FOOTER //
// promptInFeed.vue?4ae08792